<!-- Show each notification, absolutely positioned -->
<!-- Signal R -->

<i *ngFor="let pin of pins" class="bi bi-pin-fill pin" [ngStyle]="{
    position: 'absolute',
    left: pin.xCords - 15 + 'px',
    top: pin.yCords - 40 + 'px',
    zIndex: '2',
    fontSize: '30px',
    color: '#0d6efd',
    opacity: '0.9'
  }" [attr.data-notification-id]="pin.notificationId" (click)="highlightNotification($event)">
</i>

